import angular from 'angular';
import { MovimentacoesAdmissoesController } from './movimentacoes-admissoes.controller';

export class MovimentacoesAdmissoesComponent implements angular.IComponentOptions {
    static selector = 'meurhMovimentacoesAdmissoesComponent';
    static controller = MovimentacoesAdmissoesController;
    static template = require('!!html-loader!./movimentacoes-admissoes.html');
    static bindings = {
        entity: '<',
        initOpen: '<?',
        readonly: '<?'
    };
}
